<div class="lesson-tile-term-container" [ngClass]="rootClassName">
  <div class="lesson-tile-term">
    <div class="lesson-tile-term-col">
      <div class="lesson-tile-term-row">
        <span class="lesson-tile-term-text labelmediummedium">
          <span>{{name}}</span>
        </span>
      </div>
      <div class="lesson-tile-term-row1">
        <span class="lesson-tile-term-text dimmed">
          <span>{{translation}}</span>
        </span>
      </div>
    </div>
    <div class="lesson-tile-term-col1">
      <div class="lesson-tile-term-progressbar">
        <circle-progress
          class="svg status-ellipse"
          [space]="-outerStrokeWidth"
          [percent]="percent"
          [radius]="radius"
          [showTitle]="false"
          [showUnits]="false"
          [showSubtitle]="false"
          [outerStrokeWidth]="outerStrokeWidth"
          [outerStrokeColor]="'#E2C537'"
          [outerStrokeLinecap]="'square'"
          [innerStrokeWidth]="outerStrokeWidth"
          [innerStrokeColor]="'#0000000A'"
          [responsive]="false"
          [clockwise]="true"
          [startFromZero]="true"
          [lazy]="false"
          [animation]="false"
          [showImage]="false"
          [showBackground]="false"
          [showInnerStroke]="true"
          [showZeroOuterStroke]="false"
          [renderOnClick]="false"
        ></circle-progress>
      </div>
      <span class="lesson-tile-term-text-dimmed labelregularxsmall">
        <span>{{progress > 0 ? progress.toFixed(0) : '0'}}/{{count > 0 ? count : '0'}}</span>
      </span>
    </div>
  </div>
</div>
